export default __webpack_public_path__ + "static/media/trust1.4b412276.png";